import { createAction, props } from '@ngrx/store';

import {
  DateFilter,
  SearchFilter,
  SearchFilterOption,
  SearchFilterOptionsEntity,
} from './/search-filter-options.models';

export const initOptionIdsVisible = createAction(
  '[Search Page] option-ids-visible initialized',
  props<{ selectedFilterOptions: { [key: string]: string[] } }>()
);

export const initDateFilters = createAction(
  '[Search Page] Date filters initialized',
  props<{ dateFilter: DateFilter }>()
);

export const initialOptionIdsVisibleLoadSucceeded = createAction(
  '[Search Service] Initial option-ids-visible load succeeded',
  props<{ filterOptions: SearchFilterOptionsEntity[] }>()
);

export const initialOptionIdsVisibleLoadFailed = createAction(
  '[Search Service] Initial option-ids-visible load failed',
  props<{ error: string }>()
);

export const clearAllFilters = createAction('[Search Filter Modal] All filters cleared');
export const clearSearchFilterOptions = createAction('[Search Filter Modal] All search filter options cleared');
export const clearDateFilters = createAction('[Search Filter Modal] All search date filter options cleared');
export const unselectDateFilter = createAction('[Event Search Filter Chip] Unselect date filter time');
export const removeExhibitorFilter = createAction('[Exhibitor Search Filter Chip] Remove exhibitor filter');

export const optionIdsVisibleSelected = createAction(
  '[Search Page] option-ids-visible selected',
  props<{ searchFilterOption: SearchFilterOption }>()
);

export const optionIdsVisibleUnselected = createAction('[Search Page] option-ids-visible unselected');

export const optionIdsVisibleValueSelected = createAction(
  '[Search Page] option-ids-visible value selected',
  props<{ searchFilterOption: SearchFilter; searchFilterOptionValue: { key: string } }>()
);

export const optionIdsVisibleValueUnselected = createAction(
  '[Search Page] option-ids-visible value unselected',
  props<{ searchFilterOption: SearchFilter; searchFilterOptionValue: { key: string } }>()
);

export const optionIdsVisibleValuesSelected = createAction(
  '[Search Page] option-ids-visible values selected',
  props<{ searchFilterOption: SearchFilter; searchFilterOptionValues: { key: string }[] }>()
);

export const optionIdsVisibleValuesUnselected = createAction(
  '[Search Page] option-ids-visible values unselected',
  props<{ searchFilterOption: SearchFilter; searchFilterOptionValues: { key: string }[] }>()
);

export const selectedDatetimeFilterStart = createAction(
  '[Search Filter Modal] Lower date filter value selected',
  props<{ lower: number }>()
);

export const selectedDatetimeFilterEnd = createAction(
  '[Search Filter Modal] Upper date filter value selected',
  props<{ upper: number }>()
);

export const selectedDatetimeFilterReset = createAction('[Search Filter Modal] Date filter values section-actions');

export const searchFilterOptionValueChipRemoved = createAction(
  '[Search Page] Search filter option value chip removed',
  props<{ searchFilterOption: SearchFilter; searchFilterOptionValue: { key: string } }>()
);
